// extracted by mini-css-extract-plugin
export default {"piCarouselSection":"PICarouselSection_piCarouselSection__AU65i","piCarouselSectionMobileCarousel":"PICarouselSection_piCarouselSectionMobileCarousel__ocBha"};